module.exports = {
  Auth: {
    userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    mandatorySignIn: true,
    region: process.env.REACT_APP_COGNITO_REGION,
  }
}
